import { useEffect, useState } from 'react';
import { CarouselApi } from 'types/sharedComponents';

const useCarouselIsPlaying = (api: CarouselApi) => {
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    const autoplay = api?.plugins()?.autoplay;
    if (!autoplay) return;

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);
    const syncState = () => setIsPlaying(autoplay.isPlaying());

    syncState();
    // Synchronize state with autoplayer events state
    api.on('autoplay:play', handlePlay).on('autoplay:stop', handlePause).on('reInit', syncState);

    return () => {
      api.off('autoplay:play', handlePlay).off('autoplay:stop', handlePause).off('reInit', syncState);
    };
  }, [api]);

  return { isPlaying };
};

export default useCarouselIsPlaying;
